// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
import styled from 'styled-components';
import * as mixins from '@helpcenter/styles/src/mixins';
import { sizes } from '@helpcenter/styles/src/sizes-viewport';
import { isIncreasedFlexibilityEnabled } from 'feature-flags';
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line rulesdir/no-styled-export, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
export const ForgeRunnerContainer = styled.div<{ allowCustomPadding?: boolean }>`
    padding-top: 0;
    padding-bottom: 0;
    ${({ allowCustomPadding }) =>
        allowCustomPadding &&
        `
            > * {
                padding-top: ${token('space.300', '24px')};
            }
            > :first-child {
                padding-top: ${isIncreasedFlexibilityEnabled() ? token('space.400', '32px') : token('space.300', '24px')};
            }
            > :last-child {
                padding-bottom: ${isIncreasedFlexibilityEnabled() ? token('space.400', '32px') : token('space.300', '24px')};
            }
        `}
`;

// eslint-disable-next-line rulesdir/no-styled-export, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
export const StyledForgeContainer = styled.div<{ noWrapper: boolean }>`
    margin: auto;
    ${mixins.borderBox};
    margin-top: ${(props) => (props.noWrapper ? 'auto' : token('space.600', '48px'))};
    max-width: ${sizes.small}px;
    padding-left: ${token('space.600', '48px')};
    padding-right: ${token('space.600', '48px')};
    width: 100%;
`;
